import { ReactNode } from "react";
import styles from "./Actions.module.css";

function Actions({ children }: { children: ReactNode }) {
  return <div className={styles["root"]}>{children}</div>;
}

export default Actions;
